export const YOUTUBE_IFRAME_EMBED_PATTERN = /<iframe([^>]*)src=["'](https:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]+[^"']*)["']([^>]*)><\/iframe>/gi

export const FACEBOOK_IFRAME_EMBED_PATTERN = /<iframe([^>]*)src=["'](https:\/\/www\.facebook\.com\/plugins\/(post|video)\.php[^"']*)["']([^>]*)><\/iframe>/gi

export const BLOCKQUOTE_EMBED_SNS_CODE_PATTERN = /<blockquote([^>]*)class=["']([^"']*(twitter-tweet|instagram-media|text-post-media|tiktok-embed|reddit-card|reddit-embed-bq)[^"']*)["']([^>]*)>([\s\S]*?)<\/blockquote>/gi

export const SCRIPT_EMBED_SNS_CODE_PATTERN = /<script[^>]*src=["']((http|https):)?(\/\/)?(platform\.(twitter|x)\.com\/widgets\.js|www\.instagram\.com\/embed\.js|www\.threads\.(net|com)\/embed\.js|www\.tiktok\.com\/embed\.js|embed\.reddit\.com\/widgets\.js)[^"']*["'][^>]*><\/script>/gi

const EATEN_BY_JS_URL = /['\\\t\n\r]/

const decodeHtmlAttribute = value => new DOMParser()
  .parseFromString(`<i data-embed="${value}"></i>`, 'text/html')
  .querySelector('i')
  .getAttribute('data-embed')

export const escapeEmbedCode = code => code
  .replace(/&[^\s&;"'<>]{1,32};?/g, reference => {
    const decoded = decodeHtmlAttribute(reference)

    return EATEN_BY_JS_URL.test(decoded) ? decoded : reference
  })
  .replace(/['\\\t\n\r]/g, char => `&amp;#${char.charCodeAt(0)};`)
  .replace(/"/g, '&quot;')
